import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import type { MagazineFields } from '@boss/types/b2b-b2c';
import { MagazineCard } from '@boss/ui';

import MagazineCardModal from './Modal';
import { useSubmitForm } from '../../../client-queries';
import { getMagazineCardProps } from '../PropsMapper';

const MagazineCardMapper = ({ entry, locale }: { entry: MagazineFields; locale: string }) => {
  const { t } = useTranslation();
  const { mutate: sendMail, isLoading: isSendingMail } = useSubmitForm({
    toasts: {
      success: {
        title: t('common:toast.magazineSubscription.success.title') as string,
      },
    },
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const translations = t('magazineCard', {
    returnObjects: true,
  });

  const handleSubmit = (values: {
    email: string;
    firstName: string;
    lastName: string;
    subscribeNewsletter: boolean;
  }) => {
    sendMail(
      {
        email: values.email,
        firstname: values.firstName,
        lastname: values.lastName,
        subscribetonewsletter: values.subscribeNewsletter || undefined,
        url: entry?.gatedContentFile?.file?.url,
        type: 'ColoraDigitalMagazine',
      },
      {
        onSuccess: () => {
          setIsModalOpen(false);
        },
      },
    );
  };

  return (
    <>
      <MagazineCard
        onMailAction={() => {
          setIsModalOpen(true);
        }}
        {...getMagazineCardProps(entry, locale)}
        translations={translations as { mail: string }}
      />
      {isModalOpen && (
        <MagazineCardModal isLoading={isSendingMail} onCloseModal={setIsModalOpen} onSubmit={handleSubmit} />
      )}
    </>
  );
};

export default MagazineCardMapper;
